import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const TracCarMainContext = Loadable(lazy(() => import("./TracCarMainContext.jsx")));
const GeofencesPage = Loadable(lazy(() => import("./other/GeofencesPage")));
const GeofencePage = Loadable(lazy(() => import("./common/components/GeofencePage.js")));
const ReplayPage = Loadable(lazy(() => import("./other/ReplayPage.js")));

const TrackCarRoutes = [
    { path: "/tracking", element: <TracCarMainContext/> },
    { path: "/tracking/geofences", element: <GeofencesPage/> },
    { path: "/tracking/create/geofence/:id", element: <GeofencePage/> },
    { path: "/tracking/reports", element: <ReplayPage/> },
];

export default TrackCarRoutes;